/* eslint-disable react-hooks/exhaustive-deps */
import AddIcon from '@mui/icons-material/Add';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ActionButtons } from "../../../constants/actionButtons";
import { AppRoutes } from "../../../constants/appRoutes";
import FilterHelper from "../../../helpers/filterHelper";
import { buildRegionizeRoute } from "../../../helpers/regionRouteHelper";
import { TableActionColumn } from "../../../shared/components/common/tableActionColumn";
import ButtonWrapper from "../../../shared/formUtilities/useButton";
import DataTableGrid from "../../../shared/formUtilities/useTable";
import { PromotionalCodeService } from "../promotionalCodeService";
import { InitializeColumnsPromotionalCode } from "./promotionalCodeColumns";
import { PromoCodeFilter } from './promotionCodeFilter';
import { Spacing } from '../../../shared/components/common/spacing';

export const PromotionalCodeList = () => {
  const promotionalCodeService = new PromotionalCodeService();
  const queryParameters = new URLSearchParams(window.location.search);
  const [promotionalCodeList, setPromotionalCodeList] = useState([]);
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  const [filter, setFilter] = useState(null);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageCount: 0,
    perPage: 10,
    totalCount: 0,
  });
  const columns = [
    ...InitializeColumnsPromotionalCode(),
    TableActionColumn({
      visibleActionsList: [ActionButtons.Edit, ActionButtons.PromoCodeDeactivate, ActionButtons.PromoCodeActivate],
      onEdit: (e, row) => {
        onEdit(e, row);
      },
      onActivate: (e, row) => {
        onActivateOrDeactivate(row);
      },
      onDeactivate: (e, row) => {
        onActivateOrDeactivate(row);
      }
    }),
  ];

  const onActivateOrDeactivate = (row) => {
    setloading(true);
    promotionalCodeService.activateDeactivate(row?.isActive ? false : true, row?.id).then(resp => {
      getCodes();
    }).catch(err => {
      setloading(false);
    });
  };

  const onEdit = (e, row) => {
    e.stopPropagation();
    navigate(
      buildRegionizeRoute(
        `${AppRoutes.PromotionalCode}/edit/${row?.id}`
      )
    );
  };

  const onAdd = () => {
    navigate(
      buildRegionizeRoute(`${AppRoutes.PromotionalCode}/create`)
    );
  };

  function onFilter(values) {
    setFilter(values);
    onNavigate(1, pagination.perPage, values);
  }

  function onClearFilter(values) {
    onFilter('');
  }

  function onNavigate(currentPage, perPage, filterObj = filter) {
    let filterParams = filterObj ? FilterHelper.mapToParams(filterObj) : '';
    navigate({
      pathname: buildRegionizeRoute(
        `${AppRoutes.PromotionalCode}`
      ),
      search: `?currentPage=${currentPage}&perPage=${perPage}${filterParams}`,
    });
  }

  useEffect(() => {
    getCodes();
  }, [
    queryParameters.get('currentPage'),
    queryParameters.get('perPage'),
    window.location.search,
  ]);

  const getCodes = () => {
    setloading(true);
    let currentPage = queryParameters.get('currentPage')
      ? parseInt(queryParameters.get('currentPage'))
      : 1;
    let perPage = queryParameters.get('perPage')
      ? parseInt(queryParameters.get('perPage'))
      : 10;
    let filter = FilterHelper.mapFilters(queryParameters);
    promotionalCodeService
      .getCodes(currentPage, perPage, filter)
      .then((resp) => {
        setFilter(filter);
        setPagination({
          pageCount: resp.data.paging?.totalCount,
          currentPage: resp.data.paging?.currentPage,
          perPage: resp.data.paging?.perPage,
          totalCount: resp.data.paging?.totalCount,
        });
        setloading(false);
        setPromotionalCodeList(resp.data.promoCodes);
      })
      .catch((err) => {
        setloading(false);
      });
  };

  const onPageSizeChange = (e) => {
    onNavigate(1, e);
  };

  const onPageChange = (e) => {
    onNavigate(e + 1, pagination.perPage);
  };
  return (
    <>
      <PromoCodeFilter
        filter={filter}
        onHandleFilter={onFilter}
        onClearFilter={onClearFilter}></PromoCodeFilter>
      <Spacing></Spacing>
      <DataTableGrid
        hideSerialNumbers
        columnPinning={['action']}
        actionButtons={
          <ButtonWrapper
            disabled={loading}
            onClick={() => onAdd()}
            label={'Create'}
            icon={<AddIcon />}></ButtonWrapper>
        }

        name={'pcTbl'}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        columns={columns}
        heading={'Promo Code'}
        records={promotionalCodeList}
        pagination={pagination}
        showEditColumnsButton={true}
        loading={loading}></DataTableGrid>
    </>
  );
};